import React, { memo, type FC } from 'react';

import { useColumnWidth } from '../../../controllers/grid';

interface Props {
	count: number;
}

/** Renders the <colgroup /> including all the <col />. */
export const Colgroup: FC<Props> = memo(({ count }) => (
	<colgroup>
		{Array(count)
			.fill(undefined)
			.map((_, index) => (
				<Col key={index} index={index} />
			))}
	</colgroup>
));

/** Renders the <col /> which configure the DOM column widths. */
const Col = ({ index }: { index: number }) => {
	const [width] = useColumnWidth({ column: index, preview: true });
	return (
		<col
			// eslint-disable-next-line jira/react/no-style-attribute
			style={{
				width,
				minWidth: width === undefined ? '100%' : undefined /* Will remove in column resizing */,
			}}
		/>
	);
};
